import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Form, Grid } from 'semantic-ui-react'
import { AddBtn } from '../../../commonComponents/AddBtn'
import { FormTitle } from '../../../commonComponents/FormTitle'
import List from '../../../commonComponents/List'
import { CustomLoader } from '../../../commonComponents/formComponents/loader'
import PreviousDocumentsDetails from '../headerTab/previousDocumentsDetails'
import { TranslateContext } from '../TranslateContext'
import { useMultipleMerchandiseItem } from '../../hooks/useMultipleMerchandiseItem'
import InputField from '../../../commonComponents/formComponents/inputField'
import PopUpIcon from '../../../commonComponents/formComponents/PopUpIcon';
import validate from 'validate.js'
import { createRepElemMsgStructure } from '../../util/itemsTabValidation'
import * as ActionTypes from '../../actions/actionTypes'

const PreviousDocuments = ({ 
  invoiceIndex,
  merchandiseId, 
  invoiceId, 
  lineItemIndex,
  isDMS,
  isImportShipment,
  fieldPattern,
  initItemsTabValidation 
}) => {
  const dispatch = useDispatch()
  const key = 'prevDoc'
  const previousDocList =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.prevDoc) || []
  const isAgsExport=!(isImportShipment || isDMS)
  const validateMsg=React.useMemo(()=>{
    if(!isAgsExport) return ""
  
    return previousDocList.some(c=>c.docType=="N705") && previousDocList.length>1 ? "In case Doc type = 705 only 1 occurance of Previous document is allowed " :""
  },[previousDocList,isAgsExport])
    const {isLoading,AddItem,deleteItem,updateItem,saveItem, copyData}=useMultipleMerchandiseItem({tableName:key,invoiceId,merchandiseId});
  
  const { prevDoc } = fieldPattern()?.items


  const docTypeLineValidation = (prevDocIdx, docTypeValue, lineValue) => {
    const key1 = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_prevDoc${prevDocIdx+1}_line`
    const key2 = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_prevDoc${prevDocIdx+1}_docType`          
    let repElemErr = validate({docType:docTypeValue, line:lineValue},
      {docType:prevDoc()?.docType,line:prevDoc()?.line}
    ) || {}
    repElemErr = createRepElemMsgStructure(repElemErr, "prevDoc", invoiceIndex, lineItemIndex, prevDocIdx)
    dispatch({
      type: ActionTypes.UPDATE_VALIDATION_ERRORS,
      tabName:'items',
      payload:{[key1]:"",[key2]:"",...repElemErr}
    })
  }

  const displayForm=useCallback(({docType,line,id, prevDocIdx, lineErr})=>{
    if(docType!="N705") return null
    return (
      <Grid.Column width={3} className='divFormFeild border-bottom'>
       <InputField
          isLabel={false}
          id={`line${id}`}
          type='number'
          label="Line"
          value={line}
          className='field-bg'
          clearInput={false}
          errors={lineErr && [lineErr?.msg]}
          onChange={(value) =>updateItem(id, { line: value })}
          onBlur={(value) =>{
            const key1 = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_prevDoc${prevDocIdx+1}_line`
            const key2 = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_prevDoc${prevDocIdx+1}_docType`          
            let repElemErr = validate({docType:docType, line:value},
              {docType:prevDoc()?.docType,line:prevDoc()?.line}
            ) || {}
            repElemErr = createRepElemMsgStructure(repElemErr, "prevDoc", invoiceIndex, lineItemIndex, prevDocIdx)
            dispatch({
              type: ActionTypes.UPDATE_VALIDATION_ERRORS,
              tabName:'items',
              payload:{[key1]:"",[key2]:"",...repElemErr}
            })
            saveItem({ id, line: line || ' ' })
          }}
        />
      </Grid.Column>

    )
    
  },[updateItem,saveItem])
  const renderItem = useCallback(
    (item, prevDocIdx) => {
      return (
        <PreviousDocumentsDetails
          key={item.id}
          item={item}
          prevDocIdx={prevDocIdx}
          lineItemIndex={lineItemIndex}
          invoiceIndex={invoiceIndex}
          // prevDocPattern={prevDoc}
          isDMS={isDMS}
          isItemsTab={true}
          isImportShipment={isImportShipment}
          updateData={updateItem}
          deleteData={deleteItem}
          saveData={saveItem}
          copyData={copyData}
          render={isAgsExport && displayForm}
          docTypeLineValidation={docTypeLineValidation}
          initItemsTabValidation={initItemsTabValidation}
        />
      )
    },
    [updateItem, deleteItem,saveItem,copyData,docTypeLineValidation,isAgsExport]
  )

  const translate = React.useContext(TranslateContext).translate

  return (
    <Form.Group className='float-container mb-2'>
    
      <FormTitle
        boxNumber={isImportShipment ? '40' : isDMS ? '2/1' : ''}
        title={
          isImportShipment
            ? translate('DOC_PROCEDURE')
            : translate('PREVIOUS_DOCUMENT', { ns: ['default', 'lineItem', 'header'] })
        }
        errors={validateMsg &&
          <PopUpIcon
            style={{ "display": "inline" }}
            color="red"
            icon="exclamation triangle"
            popupText={validateMsg}
          />
        }
      />
        
      <List dataSource={previousDocList}  renderItem={renderItem} />

      {isLoading && <CustomLoader />}
      {previousDocList?.length < 99 && (
        <AddBtn
          id={`preDocs-add-${invoiceId}-${merchandiseId}`}
          onClick={AddItem}
          text={translate('ADD')}
        ></AddBtn>
      )}
    </Form.Group>
  )
}

export default React.memo(PreviousDocuments)
